import { useApiQuery } from "@/api";

export default function useAiChatApprovalStatus() {
  return useApiQuery(["ai_chat_get_approval_status", {}], {
    staleTime: 30_000,
  });
}
